import { Spin as SpinAnt } from "antd"
import { SpinSize } from "antd/es/spin"
import { SpinProvider } from "components/providers/Spin.provider"

type Props = {
	className?: string
	size?: SpinSize
	color?: string
}

export const Spin = ({ className, size, color }: Props) => {
	return (
		<SpinProvider color={color}>
			<SpinAnt className={className} size={size} />
		</SpinProvider>
	)
}
